<template>
  <div class="home">
    <!-- <pre style="text-align: left">{{bio.experience}}</pre> -->
    <section class="bio">
      <div class="card">
        <section class="avatar">
          <div class="image-container">
            <img :src="bio.avatar.url" alt="Norbert Nagy" v-if="bio.avatar">
          </div>
          <div class="social">
            <a target="_blank" title="Norbert Nagy - gitlab account" rel="noreferrer" href="https://gitlab.com/norbertn">
              <svg viewBox="0 0 128 128">
                <path fill="#FC6D26"
                d="M126.615 72.31l-7.034-21.647L105.64 7.76c-.716-2.206-3.84-2.206-4.556 0l-13.94 42.903H40.856L26.916
                7.76c-.717-2.206-3.84-2.206-4.557 0L8.42 50.664 1.385 72.31a4.792 4.792 0 0 0 1.74
                5.358L64 121.894l60.874-44.227a4.793 4.793 0 0 0 1.74-5.357"></path>
                <path fill="#E24329" d="M64 121.894l23.144-71.23H40.856L64 121.893z"></path>
                <path fill="#FC6D26" d="M64 121.894l-23.144-71.23H8.42L64 121.893z"></path>
                <path fill="#FCA326" d="M8.42 50.663L1.384 72.31a4.79 4.79 0 0 0 1.74 5.357L64 121.894 8.42 50.664z"></path>
                <path fill="#E24329" d="M8.42 50.663h32.436L26.916 7.76c-.717-2.206-3.84-2.206-4.557 0L8.42 50.664z"></path>
                <path fill="#FC6D26" d="M64 121.894l23.144-71.23h32.437L64 121.893z"></path>
                <path fill="#FCA326" d="M119.58 50.663l7.035 21.647a4.79 4.79 0 0 1-1.74 5.357L64 121.894l55.58-71.23z"></path>
                <path fill="#E24329" d="M119.58 50.663H87.145l13.94-42.902c.717-2.206 3.84-2.206 4.557 0l13.94 42.903z"></path>
              </svg>
            </a>
            <a target="_blank" title="Norbert Nagy - github account" rel="noreferrer" href="https://github.com/norbert989">
              <svg viewBox="0 0 128 128">
                <path fill-rule="evenodd" d="M64 5.103c-33.347 0-60.388 27.035-60.388 60.388 0 26.682 17.303 49.317 41.297 57.303 3.017.56 4.125-1.31 4.125-2.905 0-1.44-.056-6.197-.082-11.243-16.8 3.653-20.345-7.125-20.345-7.125-2.747-6.98-6.705-8.836-6.705-8.836-5.48-3.748.413-3.67.413-3.67 6.063.425 9.257 6.223 9.257 6.223 5.386 9.23 14.127 6.562 17.573 5.02.542-3.903 2.107-6.568 3.834-8.076-13.413-1.525-27.514-6.704-27.514-29.843 0-6.593 2.36-11.98 6.223-16.21-.628-1.52-2.695-7.662.584-15.98 0 0 5.07-1.623 16.61 6.19C53.7 35 58.867 34.327 64 34.304c5.13.023 10.3.694 15.127 2.033 11.526-7.813 16.59-6.19 16.59-6.19 3.287 8.317 1.22 14.46.593 15.98 3.872 4.23 6.215 9.617 6.215 16.21 0 23.194-14.127 28.3-27.574 29.796 2.167 1.874 4.097 5.55 4.097 11.183 0 8.08-.07 14.583-.07 16.572 0 1.607 1.088 3.49 4.148 2.897 23.98-7.994 41.263-30.622 41.263-57.294C124.388 32.14 97.35 5.104 64 5.104z" clip-rule="evenodd"/>
                <path d="M26.484 91.806c-.133.3-.605.39-1.035.185-.44-.196-.685-.605-.543-.906.13-.31.603-.395 1.04-.188.44.197.69.61.537.91zm2.446 2.729c-.287.267-.85.143-1.232-.28-.396-.42-.47-.983-.177-1.254.298-.266.844-.14 1.24.28.394.426.472.984.17 1.255zM31.312 98.012c-.37.258-.976.017-1.35-.52-.37-.538-.37-1.183.01-1.44.373-.258.97-.025 1.35.507.368.545.368 1.19-.01 1.452zm3.261 3.361c-.33.365-1.036.267-1.552-.23-.527-.487-.674-1.18-.343-1.544.336-.366 1.045-.264 1.564.23.527.486.686 1.18.333 1.543zm4.5 1.951c-.147.473-.825.688-1.51.486-.683-.207-1.13-.76-.99-1.238.14-.477.823-.7 1.512-.485.683.206 1.13.756.988 1.237zm4.943.361c.017.498-.563.91-1.28.92-.723.017-1.308-.387-1.315-.877 0-.503.568-.91 1.29-.924.717-.013 1.306.387 1.306.88zm4.598-.782c.086.485-.413.984-1.126 1.117-.7.13-1.35-.172-1.44-.653-.086-.498.422-.997 1.122-1.126.714-.123 1.354.17 1.444.663zm0 0"/>
              </svg>
            </a>
            <a target="_blank" title="Norbert Nagy - linkedin account" rel="noreferrer" href="https://www.linkedin.com/in/nnorbert/">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="#0077B5"
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853
                0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9
                1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337
                7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063
                2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0
                .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24
                23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </section>
        <section class="content">
          <div class="headline-text">
            <div>
              <span class="intro">Hey there! I'm</span><span class="name"> Norbert</span>
            </div>
            <div class="tagline">
              <span class="highlight">Front End Developer</span> AND
              <vue-typer
                :text='[
                "MTB Geek",
                "CSS Wizzard",
                "VUE.js Aficionado",
                "Bike Mechanic",
                "Accessibility Ninja",
                "Motorcycle Addict",
                "UI Fanatic",
                "DIY Enthusiast",
                "Web Designer"
                ]'
                :repeat='Infinity'
                :shuffle='false'
                initial-action='erasing'
                :pre-type-delay='150'
                :type-delay='70'
                :pre-erase-delay='3000'
                :erase-delay='250'
                erase-style='select-all'
                :erase-on-complete='false'
                caret-animation='blink'>
              </vue-typer>
            </div>
          </div>
          <div class="location"><md-icon>location_on</md-icon> London</div>
          <section class="about" v-if="bio.description">
            <p class="text" v-for="(section, index) in bio.description.intro" :key="index">{{ section }}</p>
          </section>
        </section>
      </div>
    </section>
    <div>
      <div class="headline-text">Work Experience</div>
        <section class="experience">
          <md-card v-for="(item, index) in bio.experience" :key="index">
            <md-card-header>
              <md-card-header-text>
                <div class="md-title">{{ item.position }}</div>
                <div class="md-subhead">{{ item.timeframe }}</div>
              </md-card-header-text>

              <md-card-media>
                <img :src="item.imageUrl" :alt="item.company">
              </md-card-media>
            </md-card-header>

            <md-card-content>
              <div>
                <md-avatar class="md-small" v-for="(tool, index) in item.tools" :key="index">
                  <img :src="tool" alt="Avatar">
                </md-avatar>
              </div>
              <div>
                <md-avatar class="md-small" v-for="(tech, index) in item.tech" :key="index">
                  <img :src="tech" alt="Avatar">
                </md-avatar>
              </div>
            </md-card-content>
          </md-card>
        </section>
    </div>
  </div>
</template>

<script>
import { VueTyper } from 'vue-typer';

export default {
  name: 'home',
  props: [
    'bio',
  ],
  data() {
    return {
      animate: false,
    };
  },
  components: {
    VueTyper,
  },
};
</script>

<style lang="scss" scoped>
  .home {
    padding: 10px;
  }

  .text {
    font-size: 1rem;
  }

  .social {
    height: 50px;
    padding: 10px;
    margin-top: -10px;
    text-align: center;
    svg {
      margin: 0 4px;
      height: 100%;
    }
  }

  .bio {
    .image-container {
      width: 240px;
      height: 240px;
      border-radius: 50%;
      overflow: hidden;
      margin: 10px auto;
    }
    img {
      height: auto;
      width: 100%;
      box-sizing: border-box;
      position: relative;
      top: -50px;
    }
    > .card {
      text-align: left;
      display: grid;
      grid-row-gap: 10px;
      grid-template-columns: 1fr;
    }
    .content {
      padding: 10px;
    }
  }

  .md-card {
    width: calc(100% - 8px);
    margin: 4px;
    display: inline-block;
    vertical-align: top;
    text-align: left;
    .md-subhead {
      opacity: 1;
    }
    &-content {
      .md-avatar {
        margin: 3px;
        border-radius: 0;
      }
    }
    &-media {
      padding-top: 10px;
      &.md-big {
        padding: 0;
        margin: 0 15px 0 0;
      }
    }

    .md-title {
      font-size: 1.2em;
    }
  }

  .experience {
    border-left: 10px solid #4fc08d;
    border-radius: 2%;
    .md-card {
      margin-left: -4px;
    }
    .md-title {
      position: relative;
      &::before{
        content: '';
        width: 23px;
        height: 23px;
        display: inline-block;
        position: absolute;
        left: -32px;
        top: 3px;
        border-radius: 50%;
        background-color: #fff;
        border: 5px solid #4fc08d;
      }
    }
  }

  .headline-text {
      font-family: 'Anton', sans-serif;
      line-height: 1.5;
      color: #4fc08d;
      font-size: 32px;
  }

  .highlight {
    margin-top: 10px;
    color: #fff;
    background-color: rgba(255, 0, 0, 0.7);
  }

  .tagline {
    font-family: 'Anton', sans-serif;
    font-size: 1.4rem;
    line-height: 1;
    letter-spacing: -0.5px;

  }

  .intro {
    font-size: 1.4rem;
    color: #000;
  }

  .name-container > span {
    font-family: 'Anton', Helvetica, sans-serif;
    font-size: 23px;
  }

  .location {
    font-size: 1.2rem;
    line-height: 2;
    .md-icon {
      position: relative;
      top: -2px;
    }
  }

  .location,
  .tagline,
  .headline-text {
    text-align: center;
  }

  @media only screen and (min-width: 960px) and (max-width: 1024px) {
    .home {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 10px;
      grid-row-gap: 10px;
    }

    .bio {
      .image-container {
        width: 140px;
        height: 140px;
      }
      img {
        top: -30px;
      }
      > .card {
        grid-template-columns: 1fr;
      }
    }
  }

  @media only screen and (min-width: 1024px) {
    .location,
    .tagline,
    .headline-text {
      text-align: left;
    }

    .home {
      display: grid;
      grid-template-columns: 2fr 1fr;
      grid-column-gap: 10px;
      grid-row-gap: 10px;
    }

    .bio {
      .image-container {
        width: auto;
        height: auto;
        border-radius: 0;
        overflow: hidden;
        margin: 10px auto;
      }
      img {
        top: 0;
      }
      > .card {
        grid-template-columns: 1fr 2fr;
      }
    }
  }
</style>
